const ageOptions = {};
for (let index = 19; index < 61; index += 1) {
  ageOptions[index] = index;
}

const heightOptions = {};
for (let i = 4; i <= 6; i += 1) {
  for (let j = 0; j <= 11; j += 1) {
    const ft = i;
    let inch = j;
    inch += (ft * 12);
    const cm = inch * 2.54;
    heightOptions[parseInt(cm, 10)] = `${i}ft ${j}in`;
  }
}


export const searchCriteriaForm = {
  from_age: {
    type: 'select',
    label: 'From age',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    options: ageOptions,
  },
  to_age: {
    type: 'select',
    label: 'To age',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    options: ageOptions,
  },
  from_height: {
    type: 'select',
    label: 'From height',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    options: heightOptions,
  },
  to_height: {
    type: 'select',
    label: 'To height',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    options: heightOptions,
  },
  marital_status: {
    type: 'async_select_multiple',
    label: 'Marital Status',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  caste: {
    type: 'async_select_multiple',
    label: 'Caste',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  profession: {
    type: 'async_select_multiple',
    label: 'Profession',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  work_profile: {
    type: 'async_select_multiple',
    label: 'Work Profile',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  qualification: {
    type: 'async_select_multiple',
    label: 'Qualification',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  study_field: {
    type: 'async_select_multiple',
    label: 'Study Field',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  degree: {
    type: 'async_select_multiple',
    label: 'Degree',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
      isOptionDisabled: (value) => {
        return value.is_parent === true;
      },
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  city: {
    type: 'async_select_multiple',
    label: 'City',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: true,
      defaultOptions: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  country: {
    type: 'async_select_multiple',
    label: 'Country',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: true,
      defaultOptions: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  bureau: {
    type: 'async_select_multiple',
    label: 'Bureau',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  income: {
    type: 'async_select_multiple',
    label: 'Income',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  is_premium: {
    type: 'async_select_multiple',
    label: 'Show Gor Maharaj (premium) profiles',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  from_india: {
    type: 'async_select_multiple',
    label: 'Candidates living in India?',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: "Doesn't Matter",
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
};


export const searchIDForm = {
  profile_id: {
    type: 'input',
    label: 'Profile ID',
    value: '',
    config: {
      placeholder: 'Enter Profile ID',
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
};


export const searchNameForm = {
  first_name: {
    type: 'input',
    label: 'First Name',
    value: '',
    config: {
      placeholder: 'Enter first name',
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  last_name: {
    type: 'input',
    label: 'Last Name',
    value: '',
    config: {
      placeholder: 'Enter last name',
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
};



// WEBPACK FOOTER //
// ./src/search/formStates.js